import React from "react";
import logger from "logger";
import { withRouter } from "react-router-dom";
import Constants from "Utils/Constants";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { showDialog } from "DialogProvider";
import IconButton from "@material-ui/core/IconButton";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import Tooltip from "@material-ui/core/Tooltip";
import CountDownTimer from "./CountDownTimer";
import Notifications from "./Notifications";
import NotificationsIcon from "@material-ui/icons/Notifications";

import "./index.scoped.css";

const MiniDrawer = (props) => {
  const user = useSelector(({ rootScope }) => rootScope.user);
  const dispatch = useDispatch();

  return (
    <>
      <div>
        <AppBar position="static" className="heading">
          <Toolbar>
            <div className="enlargeonhover">
              <a href={"#" + Constants.homepage}>
                <h1>HobbitGenie</h1>
              </a>
            </div>
            <span style={{ flex: "1" }} />
            <span style={{ padding: "10px" }}>
             <p>
                We have done some changes to prepare the site for the season and make it incredibly faster than before.
                If you face any issues with any tasks because of these changes, please reach out to us!
              </p>
              <p>
                If the website behaves weird for you, please clear browser cache
                or use incognito mode. Click on notifications for more updates.
              </p>
              {user && false && (
                <p style={{ color: "orange" }}>
                  Server will be rebooted for maintenance and updates.
                  Please ensure no task running before reboot. Reboot countdown:
                  <CountDownTimer
                    instanceMillis={new Date(
                      "March 07, 2021 01:00:00 GMT+0530"
                    ).getTime()}
                  />
                </p>
              )}
            </span>
            <span style={{ flex: "1" }} />
            {user && (
              <Tooltip title="Notifications">
                <IconButton
                  component="span"
                  onClick={() => {
                    showDialog(<Notifications open={true} />);
                  }}
                  className="enlargeonhover"
                  style={{
                    color: "white",
                    padding: "5px",
                  }}
                >
                  <NotificationsIcon />
                </IconButton>
              </Tooltip>
            )}
            {user && (
              <Tooltip title="Logout">
                <IconButton
                  component="span"
                  onClick={() => {
                    dispatch({ type: "LOGOUT" });
                    props.history.push(process.env.PUBLIC_URL + "/ui/login");
                  }}
                  className="enlargeonhover"
                  style={{
                    color: "white",
                    padding: "5px",
                  }}
                >
                  <ExitToAppIcon />
                </IconButton>
              </Tooltip>
            )}
          </Toolbar>
        </AppBar>
      </div>
    </>
  );
};

export default withRouter(MiniDrawer);
